import { AccountData, OrderPageData, OrderPageStatus } from '../api';
import { sellsMonetaryVouchers } from '../orderPage/utils/stepHelpers';

// any is here as authstate is not yet properly typed
export const getOrderPage = (account: AccountData | any, orderPageId: string) => {
  if (!account || !orderPageId) {
    return undefined;
  }
  return account.experiences[0].order_pages.find((o: OrderPageData) => o.id === orderPageId);
};

export const getOrderPages = (account: AccountData | any, withArchived?: boolean): OrderPageData[] => {
  if (!account) {
    return [];
  }
  if (withArchived) {
    return account.experiences[0].order_pages;
  }
  return account.experiences[0].order_pages.filter((x: OrderPageData) => x.status !== OrderPageStatus.ARCHIVED);
};

export const getGiftCardOrderPage = (account: AccountData | undefined): OrderPageData | undefined =>
  getOrderPages(account).find(sellsMonetaryVouchers);

export const getOrderPageLabel = (language: 'en' | 'he', orderPageData: OrderPageData[], orderPageId: string) => {
  const orderPage = orderPageData.find((x) => x.id === orderPageId);
  if (orderPage) {
    return orderPage.label[language];
  }
  return '';
};
